import axios from 'axios';
import store from '@/store/store';
import { actions as _act } from '@/models/store.actions';

export const foldersService = {
  Get,
  Add,
  Edit,
  Del,
  FoldersDocumentsChange
};

let model = {
  get baseUrl() {
    return store.getters[_act.SETT_GET_APIURLGET];
  }
};

function extract(r) {
  return r.data;
}

async function Get() {
  return axios.get(model.baseUrl + 'UserFolders/get').then(extract);
}

async function Add(pUserFolderName, pUserFolderColor, pUserFolderFontColor) {
  return axios
    .put(model.baseUrl + 'UserFolders/Add', {
      pUserFolderName: pUserFolderName,
      pUserFolderColor: pUserFolderColor,
      pUserFolderFontColor: pUserFolderFontColor
    })
    .then(extract);
}

async function Edit(pUserFolderId, pUserFolderName, pUserFolderColor, pUserFolderFontColor) {
  return axios
    .post(model.baseUrl + 'UserFolders/Edit', {
      pUserFolder_Id: pUserFolderId,
      pUserFolderName: pUserFolderName,
      pUserFolderColor: pUserFolderColor,
      pUserFolderFontColor: pUserFolderFontColor
    })
    .then(extract);
}

async function FoldersDocumentsChange(pDocuments, pUserFolders) {
  return axios
    .post(model.baseUrl + 'UserFolders/FoldersDocumentsChange', {
      pDocuments: pDocuments,
      pUserFolders: pUserFolders
    })
    .then(extract);
}

async function Del(pUserFolderId) {
  return axios
    .delete(model.baseUrl + 'UserFolders/Del', {
      data: {
        pUserFolder_Ids: pUserFolderId
      }
    })
    .then(extract);
}
